export default interface IMedicareCard {
	medicareNumber: string;
	irn: number;
	expiry: string;
}

export const InitialMedicareCardState: IMedicareCard = {
	medicareNumber: "",
	irn: 0,
	expiry: "",
};
